export enum SortDirection {
    Asc,
    Desc
}